/*
 * VISS FIX CART — drawer sempre acima de tudo.
 * Alem do z-index maximo no CSS, alguns widgets (chat/conta) injetam botoes
 * em hosts anonimos ou shadow DOM fechado com z-index igualmente maximo, e
 * ficam POR CIMA do drawer. Este guard observa a classe "open" do
 * <cart-notification>: ao abrir, esconde (visibility) qualquer flutuante
 * fixo pequeno/inferior e wrappers anonimos de scripts; ao fechar, restaura
 * exatamente o estado anterior. Nao mexe em header sticky nem no conteudo.
 */
(function () {
  if (window.__cartTopmost) return;
  window.__cartTopmost = true;

  var hidden = [];

  function restore() {
    hidden.forEach(function (pair) {
      try {
        pair[0].style.visibility = pair[1] || "";
        pair[0].style.pointerEvents = pair[2] || "";
      } catch (e) {}
    });
    hidden = [];
  }

  function hideEl(el) {
    hidden.push([el, el.style.visibility, el.style.pointerEvents]);
    el.style.setProperty("visibility", "hidden", "important");
    // pointer-events none no HOST mata o hit-test do subtree inteiro,
    // inclusive shadow DOM fechado — visibility sozinha e sobrescrivel
    // por CSS interno do widget
    el.style.setProperty("pointer-events", "none", "important");
  }

  function isHeaderBar(r) {
    // header/topbar sticky: colado no topo, largura quase total, baixinho
    return r.top <= 1 && r.width > window.innerWidth * 0.7 && r.height < window.innerHeight * 0.35;
  }

  function hideFloats() {
    restore();
    var cn = document.querySelector("cart-notification");
    [].forEach.call(document.body.children, function (el) {
      try {
        if (el === cn) return;
        var t = el.tagName;
        if (t === "SCRIPT" || t === "STYLE" || t === "LINK" || t === "TEMPLATE") return;
        if (el.classList && el.classList.contains("overlayminicart")) return;
        var cs = getComputedStyle(el);
        if (cs.visibility === "hidden" || cs.display === "none") return;
        var r = el.getBoundingClientRect();
        var isThemeSection = (el.id || "").indexOf("shopify-section-") === 0;
        if (cs.position === "fixed") {
          // header sticky fica; qualquer outro fixed (bolha de chat, banner,
          // wrapper fullscreen de app como o do WhatsApp/Pushdaddy) some
          if (!isHeaderBar(r) && !isThemeSection) {
            hideEl(el);
          } else if (!isHeaderBar(r) && isThemeSection) {
            // app embed em section: esconde so os filhos flutuantes pequenos
            [].forEach.call(el.children, function (c) {
              var cr = c.getBoundingClientRect();
              if (cr.width < 200 && cr.height < 200) hideEl(c);
            });
          }
          return;
        }
        // hosts 0x0 (inclusive shadow DOM FECHADO, que nao expoe children —
        // caso do botao do WhatsApp) fora sections do tema
        var anonHost = r.width <= 2 && r.height <= 2 && !isThemeSection;
        if (anonHost) {
          hideEl(el);
          return;
        }
        // Wrapper estatico de app com flutuante DENTRO. O launcher do Klaviyo
        // Customer Hub e assim: div#P0-7 (static, 0 de altura) > div fixed com
        // z-index 2147483646. Nao cai em nenhum dos casos acima, entao ficava
        // de fora da guarda e so nao aparecia por cima do drawer por 1 ponto
        // de z-index. Se o app subir para 2147483647 empata e ganha (vem
        // depois no DOM), caindo em cima do FINALIZAR COMPRA.
        if (!isThemeSection) hideFixosAninhados(el);
      } catch (e) {}
    });
  }

  /**
   * Procura flutuantes fixos dentro de um wrapper de app e esconde. Varredura
   * rasa e com teto de nos: roda a cada abertura do drawer, nao pode custar caro.
   */
  function hideFixosAninhados(raiz) {
    var PROFUNDIDADE_MAX = 4;
    var NOS_MAX = 120;
    var fila = [[raiz, 0]];
    var vistos = 0;
    while (fila.length && vistos < NOS_MAX) {
      var par = fila.shift();
      var no = par[0];
      var nivel = par[1];
      if (nivel >= PROFUNDIDADE_MAX) continue;
      var filhos = no.children || [];
      for (var i = 0; i < filhos.length; i++) {
        var f = filhos[i];
        vistos++;
        if (vistos > NOS_MAX) break;
        var tag = f.tagName;
        if (tag === "SCRIPT" || tag === "STYLE" || tag === "LINK" || tag === "TEMPLATE") continue;
        var cs;
        try {
          cs = getComputedStyle(f);
        } catch (e) {
          continue;
        }
        if (cs.visibility === "hidden" || cs.display === "none") continue;
        if (cs.position === "fixed") {
          // header sticky de app nao existe aqui, mas mantemos a mesma regra
          if (!isHeaderBar(f.getBoundingClientRect())) hideEl(f);
          continue; // achou o flutuante: nao precisa descer mais nesse ramo
        }
        fila.push([f, nivel + 1]);
      }
    }
  }

  var bodyWatcher = null;
  var rescanTimer = null;

  function watchBodyWhileOpen(cn) {
    if (bodyWatcher) return;
    bodyWatcher = new MutationObserver(function () {
      // widget injetado/re-injetado DEPOIS do drawer abrir tambem some
      clearTimeout(rescanTimer);
      rescanTimer = setTimeout(function () {
        if (cn.classList.contains("open")) hideFloats();
      }, 150);
    });
    bodyWatcher.observe(document.body, { childList: true });
  }

  function unwatchBody() {
    if (bodyWatcher) {
      bodyWatcher.disconnect();
      bodyWatcher = null;
    }
    clearTimeout(rescanTimer);
  }

  function watch() {
    var cn = document.querySelector("cart-notification");
    if (!cn) return;
    var apply = function () {
      if (cn.classList.contains("open")) {
        hideFloats();
        watchBodyWhileOpen(cn);
      } else {
        unwatchBody();
        restore();
      }
    };
    new MutationObserver(apply).observe(cn, {
      attributes: true,
      attributeFilter: ["class"],
    });
    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }

  // Clique "roubado" por overlay de widget: target fora do drawer mas
  // coordenadas DENTRO do rect dele. Interrompe em captura antes de chegar
  // ao handleBodyClick do tema (que fecharia o drawer sem querer).
  document.addEventListener(
    "click",
    function (e) {
      var cn = document.querySelector("cart-notification");
      if (!cn || !cn.classList.contains("open")) return;
      if (e.target && e.target.closest && e.target.closest("cart-notification")) return;
      if (!e.clientX && !e.clientY) return;
      var wrap = cn.querySelector(".minicart__wrapper");
      if (!wrap) return;
      var r = wrap.getBoundingClientRect();
      if (
        e.clientX >= r.left &&
        e.clientX <= r.right &&
        e.clientY >= r.top &&
        e.clientY <= r.bottom
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // Sacolinha do header SEMPRE abre o drawer (nunca navega pra /cart).
  // O listener original e preso por elemento na carga; o header sticky do
  // tema e um clone criado depois, sem listener — o clique nele seguia o
  // href. Delegacao em fase de captura cobre qualquer clone/re-render e
  // interrompe o listener antigo para nao togglar duas vezes.
  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest && e.target.closest("#cart-icon-bubble, .minicart__action");
      if (!trigger) return;
      var cn = document.querySelector("cart-notification");
      if (!cn || typeof cn.open !== "function") return;
      e.preventDefault();
      e.stopPropagation();
      var wrap = cn.querySelector(".minicart__wrapper");
      if (wrap && wrap.classList.contains("open")) {
        if (typeof cn.close === "function") cn.close();
      } else {
        cn.open();
      }
    },
    true
  );
})();
